// extracted by mini-css-extract-plugin
export default {"roundedDiv":"style-module--roundedDiv--N-R+7","mainDiv":"style-module--mainDiv--qG2jL"};